// extracted by mini-css-extract-plugin
module.exports = {"inner":"Ju6Aj","block":"U1g4Q","gutter_small":"_9GbeO"};